import { AWS_USERS_API } from '@/config/aws';
import { APIUser, User } from '@/models/user';
import { extractPayload } from '@/utils/api';
import { get } from 'aws-amplify/api';

const fetchUsers = async (): Promise<User[]> => {
  const options = {
    queryParams: {
      page: '1',
      perPage: '100',
    },
  };
  const { response: usersRequest } = get({
    apiName: AWS_USERS_API,
    path: '/user-admin/users',
    options,
  });
  const { data } = await extractPayload<{
    data: APIUser[];
  }>(usersRequest);

  return parseAPIUserList(data);
};

const parseAPIUserList = (data: APIUser[]): User[] => {
  return data.map((user: APIUser) => {
    return {
      id: user.user_id as string,
      email: user.email as string,
      name: user.name as string,
      organization: user.organization as string,
      status: user.status as string,
      date: new Date(user.created_at),
    };
  }) as User[];
};

export default fetchUsers;
